import { API } from '../constants/Constants';
import Instance from './interceptor';
import Toast from '../components/pages/utils/Toast';
import { DOCUMENT_TOAST, PAYMENT_TOAST } from '../constants/toastConstant';

export const getPaymentHistoryData = async () => {
  try {
    const resp = await Instance.get(`${API.PAYMENT_HISTORY_DATA}`);
    const respData = await resp?.data?.payment;

    if (respData) {
      return respData;
    }
  } catch (error) {
    Toast({ message: `${error.message}`, variant: 'error' });
  }
};

export const getPaymentHistoryDetails = async (
  sorting,
  inputValue,
  filterModel,
  filterValue,
  // dropDownValue,
  organizationId,
  page,
) => {
  const PAGE_LIMIT = 25;

  const data = {
    // stage: stageValue,
    searchData: inputValue,
    sortOrder: sorting[0]?.sort,
    sortField: sorting[0]?.colId,
    filterModel,
    organizationId,
    page,
    limit: PAGE_LIMIT,
    // documentType,
  };
  try {
    const response = await Instance.post(
      `${API.GET_ORGANIZATION_PAYMENT_HISTORY}`,
      data,
    );
    const paymentHistory = response?.data?.data;

    if (paymentHistory?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return paymentHistory;
    }
    return paymentHistory;
  } catch (error) {
    Toast({ message: `${error?.message}`, variant: 'error' });
  }
};

export const deletePayment = async (id) => {
  try {
    const resp = await Instance.delete(`${API.DELETE_PAYMENT}/${id}`);

    if (resp) {
      Toast({ message: `${resp?.data?.message}`, variant: 'success' });
      return resp?.data?.message;
    }
  } catch (error) {
    Toast({ message: `${error.message}`, variant: 'error' });
  }
};

export const addPayment = async (paymentData) => {
  try {
    const resp = await Instance.post(`${API.ADD_PAYMENT_DETAILS}`, paymentData);
    const respData = await resp?.data;

    if (respData) {
      Toast({ message: `${respData?.message}`, variant: 'success' });
      return respData;
    }
    Toast({ message: `${respData?.message}`, variant: 'error' });
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};
export const addCredit = async (payment) => {
  try {
    const resp = await Instance.post(`${API.ADD_CREDIT_DETAILS}`, payment);
    const respData = await resp?.data;
    if (respData) {
      Toast({ message: `${respData?.message}`, variant: 'success' });
      return respData;
    }
    Toast({ message: `${respData?.message}`, variant: 'error' });
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};
export const addSalesAdminAndSalesCredit = async (credit) => {
  try {
    const resp = await Instance.post(`${API.ADD_SALES_TEAM_CREDIT}`, credit);
    const respData = await resp?.data;
    if (respData) {
      Toast({ message: `${respData?.message}`, variant: 'success' });
      return respData;
    }
    Toast({ message: `${respData?.message}`, variant: 'error' });
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};

export const FilterPaymentData = async (selectedOrganizations) => {
  const requestData = {
    field: selectedOrganizations,
  };
  try {
    const response = await Instance.post(
      `${API.FILTER_SORT_PAYMENT_DATA}`,
      requestData,
    );
    if (response?.data?.documents.length === 0) {
      Toast({
        message: PAYMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return response;
    }
    return response;
  } catch (error) {
    Toast({ message: `${error.message}`, variant: 'error' });
  }
};

export const SortPaymentApi = async (selectedOrganizations, sorting) => {
  const requestData = {
    field: selectedOrganizations,
  };
  try {
    return await Instance.post(`${API.FILTER_SORT_PAYMENT_DATA}`, requestData, {
      params: { sortField: sorting.column, sortOrder: sorting.sort },
    });
  } catch (error) {
    return error;
  }
};

export const downloadDocument = async (id) => {
  try {
    return await Instance.get(`${API.DOWNLOAD_DOCUMENT}/${id}`);
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};
